<template>
    <rkm-area
        type="fieldset"
        title="Temas para reunião"
        v-if="showReuniao"
    >   

        <rkm-row>
            <rkm-col>
                <rkm-form-group>
                    <rkm-form-checkbox-group
                        v-model="data.model.reuniaoTemas"
                        name="Temas para reunião"
                        :validations="validations.reuniao"
                    >
                        <rkm-row>
                            <rkm-col
                                v-for="item in data.form.reuniaoTemas"
                                v-bind:key="item.id"
                                cols="6"
                            >
                                <rkm-form-checkbox
                                    :value="item.id"
                                    class="text-nowrap"
                                    inline
                                >
                                    {{ item.descricao }}
                                </rkm-form-checkbox>
                            </rkm-col>
                        </rkm-row>
                    </rkm-form-checkbox-group>
                </rkm-form-group>
            </rkm-col>
        </rkm-row>

    </rkm-area>
</template>

<script>

//Enums
import atividadeTipo from '@/enums/atencao-basica/atividade-coletiva/atividadeTipo'

export default {
    data: () => ({
        enums: {
            atividadeTipo
        },
    }),
    computed: {
        showReuniao() {
            const atividadeTipoId = this.data.model.atividade.atividadeTipoId

            const tiposAtividade = [
                this.enums.atividadeTipo.REUNIAO_DE_EQUIPE,
                this.enums.atividadeTipo.REUNIAO_COM_OUTRAS_EQUIPES_DE_SAUDE,
                this.enums.atividadeTipo.REUNIAO_INTERSETORIAL_CONSELHO_LOCAL_DE_SAUDE_CONTROLE_SOCIAL
            ]

            return this.data.model.reuniaoTemas && tiposAtividade.includes(atividadeTipoId)
        },
        validations() {
            return {
                reuniao: {
                    required: this.isRequiredReuniao
                }
            }
        },
        isRequiredReuniao() {
            const tiposAtividade = [
                this.enums.atividadeTipo.REUNIAO_DE_EQUIPE,
                this.enums.atividadeTipo.REUNIAO_COM_OUTRAS_EQUIPES_DE_SAUDE,
                this.enums.atividadeTipo.REUNIAO_INTERSETORIAL_CONSELHO_LOCAL_DE_SAUDE_CONTROLE_SOCIAL
            ]

            return tiposAtividade.includes(this.data.model.atividade.atividadeTipoId)
        }
    },
    watch: {
        'data.model.atividade.atividadeTipoId': function (atividade) {

            const atividadeTipoId = atividade

            const tiposAtividade = [
                this.enums.atividadeTipo.REUNIAO_DE_EQUIPE,
                this.enums.atividadeTipo.REUNIAO_COM_OUTRAS_EQUIPES_DE_SAUDE,
                this.enums.atividadeTipo.REUNIAO_INTERSETORIAL_CONSELHO_LOCAL_DE_SAUDE_CONTROLE_SOCIAL
            ]

            if (!tiposAtividade.includes(atividadeTipoId)) {
                this.data.model.reuniaoTemas = []
            }
        },
    },
    props: {
        data: { type: Object, required: false, },
    }
}
</script>